const cars = [
	{
		id: 1,
		name: "Audi S-Class",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "Audi.jpeg",
	},
	{
		id: 2,
		name: "BMW 3 Series",
		modelYear: 2019,
		mileage: 8.2,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 350,
		image: "bmw.jpeg",
	},
	{
		id: 3,
		name: "Jaguar",
		modelYear: 2020,
		mileage: 5.6,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 400,
		image: "jaguar.jpg",
	},
	{
		id: 4,
		name: "Bugatti",
		modelYear: 2020,
		mileage: 7.7,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 620,
		image: "bugatti-2.jpg",
	},
	{
		id: 5,
		name: "BMW 4 Series GTI",
		modelYear: 2021,
		mileage: 7.6,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 530,
		image: "bmw-2.jpg",
	},
	{
		id: 6,
		name: "Mercedez-Benz G-Class",
		modelYear: 2019,
		mileage: 7.2,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 490,
		image: "mercedez.jpg",
	},
	{
		id: 7,
		name: "Lamborgini Urus",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "lamborgini_urus.jpg",
	},
	{
		id: 8,
		name: "Rolls Royce Ghost",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "rolls-royce.jpg",
	},
	{
		id: 9,
		name: "Bugatti",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "bugatti.jpg",
	},
	{
		id: 10,
		name: "Lamborgini Avtendor",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "lamborgini_avtendor.jpg",
	},
	{
		id: 11,
		name: "Audi S-Class",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "Audi.jpeg",
	},
	{
		id: 12,
		name: "BMW 3 Series",
		modelYear: 2019,
		mileage: 8.2,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 350,
		image: "bmw.jpeg",
	},
	{
		id: 13,
		name: "Jaguar",
		modelYear: 2020,
		mileage: 5.6,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 400,
		image: "jaguar.jpg",
	},
	{
		id: 14,
		name: "Bugatti",
		modelYear: 2020,
		mileage: 7.7,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 620,
		image: "bugatti-2.jpg",
	},
	{
		id: 15,
		name: "BMW 4 Series GTI",
		modelYear: 2021,
		mileage: 7.6,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 530,
		image: "bmw-2.jpg",
	},
	{
		id: 16,
		name: "Mercedez-Benz G-Class",
		modelYear: 2019,
		mileage: 7.2,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 490,
		image: "mercedez.jpg",
	},
	{
		id: 17,
		name: "Lamborgini Urus",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "lamborgini_urus.jpg",
	},
	{
		id: 18,
		name: "Rolls Royce Ghost",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "rolls-royce.jpg",
	},
	{
		id: 19,
		name: "Bugatti",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "bugatti.jpg",
	},
	{
		id: 20,
		name: "Lamborgini Avtendor",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "lamborgini_avtendor.jpg",
	},
	{
		id: 21,
		name: "Audi S-Class",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "Audi.jpeg",
	},
	{
		id: 22,
		name: "BMW 3 Series",
		modelYear: 2019,
		mileage: 8.2,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 350,
		image: "bmw.jpeg",
	},
	{
		id: 23,
		name: "Jaguar",
		modelYear: 2020,
		mileage: 5.6,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 400,
		image: "jaguar.jpg",
	},
	{
		id: 24,
		name: "Bugatti",
		modelYear: 2020,
		mileage: 7.7,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 620,
		image: "bugatti-2.jpg",
	},
	{
		id: 25,
		name: "BMW 4 Series GTI",
		modelYear: 2021,
		mileage: 7.6,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 530,
		image: "bmw-2.jpg",
	},
	{
		id: 26,
		name: "Mercedez-Benz G-Class",
		modelYear: 2019,
		mileage: 7.2,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 490,
		image: "mercedez.jpg",
	},
	{
		id: 27,
		name: "Lamborgini Urus",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "lamborgini_urus.jpg",
	},
	{
		id: 28,
		name: "Rolls Royce Ghost",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "rolls-royce.jpg",
	},
	{
		id: 29,
		name: "Bugatti",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "bugatti.jpg",
	},
	{
		id: 30,
		name: "Lamborgini Avtendor",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "lamborgini_avtendor.jpg",
	},
	{
		id: 31,
		name: "Audi S-Class",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "Audi.jpeg",
	},
	{
		id: 32,
		name: "BMW 3 Series",
		modelYear: 2019,
		mileage: 8.2,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 350,
		image: "bmw.jpeg",
	},
	{
		id: 33,
		name: "Jaguar",
		modelYear: 2020,
		mileage: 5.6,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 400,
		image: "jaguar.jpg",
	},
	{
		id: 34,
		name: "Bugatti",
		modelYear: 2020,
		mileage: 7.7,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 620,
		image: "bugatti-2.jpg",
	},
	{
		id: 35,
		name: "BMW 4 Series GTI",
		modelYear: 2021,
		mileage: 7.6,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 530,
		image: "bmw-2.jpg",
	},
	{
		id: 36,
		name: "Mercedez-Benz G-Class",
		modelYear: 2019,
		mileage: 7.2,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 490,
		image: "mercedez.jpg",
	},
	{
		id: 37,
		name: "Lamborgini Urus",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "lamborgini_urus.jpg",
	},
	{
		id: 38,
		name: "Rolls Royce Ghost",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "rolls-royce.jpg",
	},
	{
		id: 39,
		name: "Bugatti",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "bugatti.jpg",
	},
	{
		id: 40,
		name: "Lamborgini Avtendor",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "lamborgini_avtendor.jpg",
	},
	{
		id: 41,
		name: "Audi S-Class",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "Audi.jpeg",
	},
	{
		id: 42,
		name: "BMW 3 Series",
		modelYear: 2019,
		mileage: 8.2,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 350,
		image: "bmw.jpeg",
	},
	{
		id: 43,
		name: "Jaguar",
		modelYear: 2020,
		mileage: 5.6,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 400,
		image: "jaguar.jpg",
	},
	{
		id: 44,
		name: "Bugatti",
		modelYear: 2020,
		mileage: 7.7,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 620,
		image: "bugatti-2.jpg",
	},
	{
		id: 45,
		name: "BMW 4 Series GTI",
		modelYear: 2021,
		mileage: 7.6,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 530,
		image: "bmw-2.jpg",
	},
	{
		id: 46,
		name: "Mercedez-Benz G-Class",
		modelYear: 2019,
		mileage: 7.2,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 490,
		image: "mercedez.jpg",
	},
	{
		id: 47,
		name: "Lamborgini Urus",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "lamborgini_urus.jpg",
	},
	{
		id: 48,
		name: "Rolls Royce Ghost",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "rolls-royce.jpg",
	},
	{
		id: 49,
		name: "Bugatti",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "bugatti.jpg",
	},
	{
		id: 50,
		name: "Lamborgini Avtendor",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "lamborgini_avtendor.jpg",
	},
	{
		id: 51,
		name: "Audi S-Class",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "Audi.jpeg",
	},
	{
		id: 52,
		name: "BMW 3 Series",
		modelYear: 2019,
		mileage: 8.2,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 350,
		image: "bmw.jpeg",
	},
	{
		id: 53,
		name: "Jaguar",
		modelYear: 2020,
		mileage: 5.6,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 400,
		image: "jaguar.jpg",
	},
	{
		id: 54,
		name: "Bugatti",
		modelYear: 2020,
		mileage: 7.7,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 620,
		image: "bugatti-2.jpg",
	},
	{
		id: 55,
		name: "BMW 4 Series GTI",
		modelYear: 2021,
		mileage: 7.6,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 530,
		image: "bmw-2.jpg",
	},
	{
		id: 56,
		name: "Mercedez-Benz G-Class",
		modelYear: 2019,
		mileage: 7.2,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 490,
		image: "mercedez.jpg",
	},
	{
		id: 57,
		name: "Lamborgini Urus",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "lamborgini_urus.jpg",
	},
	{
		id: 58,
		name: "Rolls Royce Ghost",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "rolls-royce.jpg",
	},
	{
		id: 59,
		name: "Bugatti",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "bugatti.jpg",
	},
	{
		id: 60,
		name: "Lamborgini Avtendor",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "lamborgini_avtendor.jpg",
	},
	{
		id: 61,
		name: "Audi S-Class",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "Audi.jpeg",
	},
	{
		id: 62,
		name: "BMW 3 Series",
		modelYear: 2019,
		mileage: 8.2,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 350,
		image: "bmw.jpeg",
	},
	{
		id: 63,
		name: "Jaguar",
		modelYear: 2020,
		mileage: 5.6,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 400,
		image: "jaguar.jpg",
	},
	{
		id: 64,
		name: "Bugatti",
		modelYear: 2020,
		mileage: 7.7,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 620,
		image: "bugatti-2.jpg",
	},
	{
		id: 65,
		name: "BMW 4 Series GTI",
		modelYear: 2021,
		mileage: 7.6,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 530,
		image: "bmw-2.jpg",
	},
	{
		id: 66,
		name: "Mercedez-Benz G-Class",
		modelYear: 2019,
		mileage: 7.2,
		seats: 4,
		fuel_type: "Gasoline",
		drive_mode: "Automatic",
		price_per_month: 490,
		image: "mercedez.jpg",
	},
	{
		id: 67,
		name: "Lamborgini Urus",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "lamborgini_urus.jpg",
	},
	{
		id: 68,
		name: "Rolls Royce Ghost",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "rolls-royce.jpg",
	},
	{
		id: 69,
		name: "Bugatti",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "bugatti.jpg",
	},
	{
		id: 70,
		name: "Lamborgini Avtendor",
		modelYear: 2016,
		mileage: 6.4,
		seats: 4,
		fuel_type: "Hybrid",
		drive_mode: "Automatic",
		price_per_month: 440,
		image: "lamborgini_avtendor.jpg",
	},
];

export default cars;
